module.exports = __webpack_public_path__ + "static/img/9bg_3.485103f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_3.png
// module id = 775
// module chunks = 1